import { SubtaskModeSubtask } from 'types';

export const getTaskTime = (subtasks: SubtaskModeSubtask[]) => {
  return subtasks.reduce(
    (acc, subtask) => {
      acc.plannedHours += subtask.plannedHours;
      acc.actualHours += subtask.actualHours;
      acc.templateHours += subtask.templateHours;

      return acc;
    },
    { plannedHours: 0, actualHours: 0, templateHours: 0 }
  );
};
